export default {
  default: {
    bath: 'Bath',
    bed: 'Bed',
    car: 'Car',
  },
}
